import React, { useState } from 'react';
import { Button } from "../components/ui/button";
import SimplifiedESGForm from './SimplifiedESGForm';

const DemoOnboarding = ({ onComplete }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [step, setStep] = useState(0);
  const [formData, setFormData] = useState({
    companyName: '',
    industry: '',
    employeeCount: '',
    trackCarbonEmissions: false,
    energyConsumption: '',
    womenPercentage: '',
    hasBoard: false,
    hasEthicsCode: false,
  });

  const handleFormDataChange = (newData) => {
    setFormData(newData);
  };

  const handleComplete = () => {
    setIsOpen(false);
    onComplete(formData);
    // Reset the form data and step after completion
    setFormData({
      companyName: '',
      industry: '',
      employeeCount: '',
      trackCarbonEmissions: false,
      energyConsumption: '',
      womenPercentage: '',
      hasBoard: false,
      hasEthicsCode: false,
    });
    setStep(0);
  };

  const steps = [
    {
      title: "Welcome to ESGrity.AI",
      content: "Let's set up your company's ESG profile with some basic information. This will help us provide you with tailored insights and recommendations.",
    },
    {
      title: "Enter Your ESG Data",
      content: <SimplifiedESGForm initialData={formData} onDataChange={handleFormDataChange} />,
    },
    {
      title: "Data Submitted Successfully",
      content: "Great! We've received your initial ESG data. Click 'Complete' to see how this data affects your dashboard.",
    },
  ];

  const handleNext = () => {
    if (step < steps.length - 1) {
      setStep(step + 1);
    } else {
      handleComplete();
    }
  };

  const handlePrevious = () => {
    if (step > 0) {
      setStep(step - 1);
    }
  };

  if (!isOpen) {
    return <Button onClick={() => setIsOpen(true)}>Try Demo Onboarding</Button>;
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg max-w-md w-full">
        <h2 className="text-xl font-bold mb-4">{steps[step].title}</h2>
        <div className="py-4">
          {typeof steps[step].content === 'string' 
            ? <p>{steps[step].content}</p> 
            : steps[step].content
          }
        </div>
        <div className="flex justify-between mt-4">
          <Button onClick={handlePrevious} disabled={step === 0}>
            Previous
          </Button>
          <Button onClick={handleNext}>
            {step === steps.length - 1 ? "Complete" : "Next"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DemoOnboarding;